import { init } from '../utils/init';
import initCartQuantity from '../components/cart-quantity';

init((): void => {
  initCartQuantity();
});
